<template>
    <div id="tab">
        <ul>
            <li @click="goHome" :class="{check:isHome}"><span class="sp_home"></span><p>{{$t("trade.tab.home")}}</p></li>
            <li @click="goPosition" :class="{check:isPosition}"><span class="sp_position"></span><p>{{$t("trade.tab.position")}}</p></li>
            <li @click="goTrade" :class="{check:isTrade}"><span class="sp_market"></span><p>{{$t("trade.tab.market")}}</p></li>
            <li @click="goMyself" :class="{check:isMyself}"><span class="sp_me"></span><p>{{$t("trade.tab.me")}}</p></li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Tab",
        computed: {
            ...mapState(['quote']),
            tickList: {
                get() {
                    let newTickList=[];
                    // for (const i in this.quote.tickList) {
                    //     if(this.uiCodeIDs.indexOf(this.quote.tickList[i].uiCodeID) >= 0){
                    //         newTickList.push(this.quote.tickList[i]);
                    //     }
                    // }
                    
                    let codes = process.env.VUE_APP_PRODUCTS.split(",");
                    for(const i in codes){
                        for(const j in this.quote.tickList){
                            if(codes[i] == this.quote.tickList[j].uiCodeID){
                                newTickList.push(this.quote.tickList[j]);
                                break;
                            }
                        }
                   
                    }
                    return newTickList;
                }
            }
        },
        data(){
            return{
                isHome:false,
                isPosition:false,
                isTrade:false,
                isMyself:false
            }
        },
        methods:{
            goHome(){
                if (this.$route.path === '/home') {
                    return;
                }
                this.$bus.$emit('loading', false);
                this.$router.replace({path:'/home'});
            },
            goPosition(){
                if (this.$route.path === '/home/quoteChart') {
                    return;
                }
                this.$bus.$emit('loading', false);
                this.$router.replace({path:'/home/quoteChart',query: {id: this.tickList[0].uiCodeID,index:0}});
            },
            goTrade(){
                if (this.$route.path === '/home/trade') {
                    return;
                }
                this.$bus.$emit('loading', false);
                this.$router.replace({path:'/home/trade'});
            },
            goMyself(){
                if (this.$route.path === '/home/myself') {
                    return;
                }
                this.$bus.$emit('loading', false);
                this.$router.replace({path:'/home/myself'});
            },
        },
        mounted(){
            if (this.$route.path=="/home") {
                this.isHome=true;
            }else if (this.$route.path=="/home/quoteChart") {
                this.isPosition=true;
            }else if (this.$route.path=="/home/trade"||this.$route.path=='/home/positionChart'||this.$route.path=='/home/pendingChart') {
                this.isTrade=true;
            }else if(this.$route.path=="/home/myself") this.isMyself=true
        }
    }
</script>
